import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CollapsibleSection } from './CollapsibleSection';

export const PetversePreview = ({ isOpen, onToggle }) => {
  const { t } = useLanguage();

  return (
    <CollapsibleSection
      id="petverse-section"
      title={
        <span className="inline-flex items-center gap-2">
          <span className="text-2xl">🛡️</span>
          {t('petverseHeading')}
        </span>
      }
      isOpen={isOpen}
      onToggle={onToggle}
      testId="petverse-preview-toggle"
    >
      <div className="text-center">
        <p className="text-sm text-slate-400 max-w-2xl mx-auto mb-4 leading-relaxed">
          {t('petverseText')}
        </p>
        <a
          href="https://petechtor.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors text-sm"
        >
          <span>{t('petverseVisit')}</span>
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </CollapsibleSection>
  );
};
